import request from '@/utils/request-public'


export function docCenterMenuList(data) {
    return request({
        url: '/api/common/v1/docCenter/docCenterMenuList',
        method: 'post',
        data
    })
}

export function docCenterCmsGetByColumnId(data) {
    return request({
        url: '/api/common/v1/docCenter/docCenterCmsGetByColumnId',
        method: 'post',
        data
    })
}

export function problemListOpen(data) {
    return request({
        url: '/api/common/v1/manager/cms/problem/problemListOpen',
        method: 'post',
        data
    })
}

